import React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Button from '@components/atoms/button/button';
import styles from '../products.module.scss';

const LoadMoreView: React.FC<{
  onClick: () => void;
  loading: boolean;
}> = ({ onClick, loading }) => {
  const { t } = useTranslation('orders-sales');
  return (
    <div className={styles.ordersSales__mainLeft__products__loadMore}>
      <Button
        variant="outline"
        size="medium"
        className={clsx(
          loading ? styles['ordersSales__mainLeft__products__loadMore__btn--loading'] : '',
          styles.ordersSales__mainLeft__products__loadMore__btn,
        )}
        disabled={loading}
        onClick={onClick}
        data-cy="load_more_cta"
      >
        {t('MY_ACCOUNT.ORDERS_SALES.LIST.LOAD_MORE')}
      </Button>
    </div>
  );
};

export default LoadMoreView;
